import React from 'react';
import PropTypes from 'prop-types';

import { Button, PlusCircleIcon } from '@metarouter-private/mr-mui';
import isAllowedToWritePipelineSchemaLibrary from '@ion/api/pipeline-schema-libraries/isAllowedToWritePipelineSchemaLibrary';
import { useQueryAllSchemaLibraries } from '@ion/api';
import WithTooltip from 'app/components/WithTooltip';

const ADD_SCHEMA_LIBRARY_BUTTON_LABEL = 'Add Schema Library';
const DISABLED_LABEL = 'No Schema Libraries Available';

const DEFAULT_BUTTON_PROPS = {
  variant: 'outlined',
  color: 'secondary',
  startIcon: <PlusCircleIcon />,
  'data-test-id': 'addSchemaLibraryButton',
};

export default function AddSchemaLibraryButton({ onClick }) {
  const { data: schemaLibraries } = useQueryAllSchemaLibraries();
  const hasPermission = isAllowedToWritePipelineSchemaLibrary();
  const areLibrariesAvailable = schemaLibraries.length > 0;
  const isButtonDisabled = !hasPermission || !areLibrariesAvailable;

  return (
    <WithTooltip show={isButtonDisabled} title={DISABLED_LABEL}>
      <Button {...DEFAULT_BUTTON_PROPS} onClick={onClick} disabled={isButtonDisabled}>
        {ADD_SCHEMA_LIBRARY_BUTTON_LABEL}
      </Button>
    </WithTooltip>
  );
}

AddSchemaLibraryButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
